import http from '../utils/http';
import i18n from '@/main';

const baseRoute = '/operacao/monitoramento';

export default {
    buscarDadosMonitoramento(idOperacao) {
        return http.get({
            url: baseRoute + `/${idOperacao}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeMonitoramento')
        });
    },

    buscarDadosAnaliseTerritorio(idOperacao, idTerritorio) {
        return http.get({
            url: baseRoute + `/${idOperacao}/territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeAnaliseDoTerritorio')
        });
    },

    buscarDadosAnalisePessoa(idOperacao, idPessoa) {
        return http.get({
            url: baseRoute + `/${idOperacao}/pessoa/${idPessoa}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeAnaliseDaPessoa')
        });
    },

    buscarOperacoesInibicao(payload, lockScreen = false) {
        return http.post({
            url: baseRoute + '/operacoes-inibicao',
            data: payload,
            lockScreen: lockScreen
        });
    },
    buscarJustificativasInibirRestricoes() {
        return http.get({
            url: baseRoute + '/justificativas-inibicao',
            lockScreen: false
        });
    },
    inibirRestricao(payload) {
        return http.post({
            url: baseRoute + '/inibicao-restricao',
            data: payload,
            lockScreen: true
        });
    },
    editarRestricao(payload) {
        return http.post({
            url: baseRoute + '/inibicao-restricao/editar',
            data: payload,
            lockScreen: true
        });
    },
    buscarInibicaoRestricaoOperacao(payload) {
        return http.post({
            url: baseRoute + '/buscar/inibicao',
            data: payload,
            lockScreen: true
        });
    },
    buscarDadosInibicao(payload) {
        return http.post({
            url: baseRoute + '/buscar/inibicao/edicao',
            data: payload,
            lockScreen: true
        });
    }
};
